<template>
<el-input class="color-picker" :placeholder="placeholder" ref="input" v-clickoutside="showPicker = false" :value="displayValue" :size="size" :readonly="!editable" @click.native="handleColorPicker" @change="emitChange" :disabled="disabled">
  <template slot="prefix"> <el-color-picker v-model="color" ref="colorPicker" :show-alpha="showAlpha" :size="size" @click.native="onClickColorPicker" @change="handleChange" :disabled="disabled"></el-color-picker></template>
</el-input>
</template>

<script>
import Clickoutside from 'element-ui/src/utils/clickoutside';

export default {
  name: 'WColorField',
  directives: { Clickoutside },
  props: {
    value: String,
    showAlpha: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'mini',
    },
    placeholder: {
      type: String,
      default: '색상',
    },
  },
  data() {
    return {
      color: this.value === undefined || this.value === null ? '' : this.value,
      showColorPicker: false,
    };
  },
  computed: {
    displayValue() {
      return this.color;
    },
  },
  watch: {
    value(val) {
      this.color = val;
    },
  },
  methods: {
    /**
     * ColorPicker를 보이거나 숨긴다.
     * @author Ju
     * @return {[type]} [description]
     */
    handleColorPicker() {
      if (this.showColorPicker) {
        this.$refs.colorPicker.hide();
        this.showColorPicker = false;
      } else {
        this.$refs.colorPicker.handleTrigger();
        this.showColorPicker = true;
      }
    },
    handleChange(value) {
      this.$emit('input', value);
    },
    /**
     * ElColorPicker 클릭 시 이벤트 전파를 방지한다. (handleColorPicker 기능 충돌 방지)
     * @author Ju
     * @param  {[type]} e [이벤트 객체]
     * @return {[type]}   [description]
     */
    onClickColorPicker(e) {
      e.stopPropagation();
    },
    emitChange(val) {
      this.$emit('change', val);
    },
  },
};
</script>

<style>
.color-picker .el-color-picker__trigger {
  border: none;
}

.color-picker .el-input--prefix .el-input__inner {
  padding-left: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/form/ColorField.vue